import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

const defaultBreakpoints = {
	667: {
		slidesPerView: 2,
		spaceBetween: 32,
	},
	1024: {
		slidesPerView: 3,
		spaceBetween: 32,
	},
};

const isObject = ( value ) => typeof value === 'object' && value !== null && ! Array.isArray( value );

const mergeDeep = ( target = {}, source = {} ) => {
	const output = { ...target };

	Object.keys( source ).forEach( ( key ) => {
		if ( isObject( source[ key ] ) ) {
			output[ key ] = mergeDeep( target[ key ] || {}, source[ key ] );
			return;
		}

		output[ key ] = source[ key ];
	} );

	return output;
};

const getModules = ( customModules ) => {
	if ( ! Array.isArray( customModules ) ) {
		return [ Scrollbar ];
	}

	const mergedModules = [ Scrollbar, ...customModules ];

	return mergedModules.filter( ( module, index ) => mergedModules.indexOf( module ) === index );
};

const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

/**
 * Initialize Swiper sliders with shared defaults.
 *
 * @param {string} selector CSS selector targeting the Swiper container(s).
 * @param {object} options Optional Swiper configuration overrides.
 * @returns {Array} Array of Swiper instances.
 */
export const initSwiperSlider = ( selector = '.js-swiperSlider', options = {} ) => {
	if ( typeof window === 'undefined' ) {
		return [];
	}

	const sliders = document.querySelectorAll( selector );
	const instances = [];

	if ( ! sliders.length ) {
		return instances;
	}

	sliders.forEach( ( slider ) => {
		if ( slider.dataset.swiperInitialized === 'true' ) {
			return;
		}

		const slideCount = slider.querySelectorAll( '.swiper-slide' ).length;
		const scrollbar = slider.querySelector( '.swiper-scrollbar' );
		const allowDragging = isTouchDevice() ? slideCount >= 2 : slideCount >= 3;

		const baseConfig = {
			modules: getModules( options.modules ),
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: defaultBreakpoints,
			scrollbar: {
				draggable: true,
				dragSize: 'auto',
			},
		};

		const config = mergeDeep( baseConfig, options );

		if ( typeof options.grabCursor === 'undefined' ) {
			config.grabCursor = allowDragging;
		}

		if ( typeof options.allowTouchMove === 'undefined' ) {
			config.allowTouchMove = allowDragging;
		}

		if ( config.scrollbar !== false ) {
			config.scrollbar = scrollbar ? { ...config.scrollbar, el: scrollbar } : false;
		}

		const swiper = new Swiper( slider, config );

		slider.dataset.swiperInitialized = 'true';
		instances.push( swiper );
	} );

	return instances;
};

